import { useState } from "react";
import { CheckCircle2, ArrowRight } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";

const SYSTEMS = [
  ["s3", "Directie / management", "Systeem III"],
  ["s5", "Raad van commissarissen / eigenaar", "Systeem V"],
  ["s4", "Strategie, innovatie of ontwikkeling", "Systeem IV"],
  ["s2", "Planning, HR, kwaliteit of co\u00f6rdinatie", "Systeem II"],
  ["s1", "Uitvoering / operatie", "Systeem I"],
];
const FIELDS = [
  ["organization", "Naam organisatie", "text"],
  ["name", "Je naam", "text"],
  ["function", "Je functie", "text"],
  ["phone", "Telefoonnummer", "tel"],
  ["email", "E-mailadres", "email"],
];

export const DemoRequestForm = ({ onStarted }) => {
  const [f, setF] = useState({ organization: "", name: "", function: "", phone: "", email: "", system: "s3", website: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.phone.replace(/\D/g, "").length < 6) {
      setError("Vul een geldig telefoonnummer in.");
      return;
    }
    if ([f.organization, f.name, f.function].some((v) => v.trim().length < 2)) {
      setError("Vul de naam van de organisatie, je naam en je functie in.");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/demo-requests", f);
      if (data.id) onStarted({ id: data.id, token: data.token });
      else setDone(true);
    } catch (err) {
      setError(err.response?.status === 429 ? formatApiErrorDetail(err.response.data.detail) : "Versturen mislukt, controleer je gegevens.");
    }
    setBusy(false);
  };

  if (done) {
    return (
      <div className="border border-white/30 p-8 space-y-3" data-testid="demo-request-success">
        <CheckCircle2 className="h-8 w-8" />
        <h3 className="font-grotesk text-2xl font-bold">Dank je, {f.name.split(" ")[0]}!</h3>
        <p className="text-zinc-300 leading-relaxed">
          Je gegevens zijn ontvangen. We nemen contact met je op voor de verdere stappen.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="demo-request-form">
      <div className="grid sm:grid-cols-2 gap-4">
        {FIELDS.map(([k, l, t]) => (
          <div key={k} className={k === "organization" ? "sm:col-span-2" : ""}>
            <Label className="text-[11px] uppercase tracking-widest text-zinc-400">{l}</Label>
            <Input type={t} required value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })}
              className="mt-1 rounded-none bg-transparent border-white/40 text-white focus-visible:ring-white focus-visible:border-white" data-testid={`demo-${k}-input`} />
          </div>
        ))}
      </div>
      <input tabIndex={-1} autoComplete="off" value={f.website} onChange={(e) => setF({ ...f, website: e.target.value })} className="hidden" aria-hidden="true" name="website" />
      <div>
        <Label className="text-[11px] uppercase tracking-widest text-zinc-400">Waar werk je in de organisatie?</Label>
        <div className="mt-2 grid sm:grid-cols-2 gap-2" data-testid="demo-system-options">
          {SYSTEMS.map(([k, l, s]) => (
            <button key={k} type="button" onClick={() => setF({ ...f, system: k })} data-testid={`demo-system-${k}`}
              className={`text-left px-3 py-2 border transition-colors ${f.system === k ? "bg-white text-zinc-900 border-white" : "border-white/30 hover:border-white"}`}>
              <span className="block text-sm font-medium">{l}</span>
              <span className={`block text-[10px] font-mono uppercase tracking-widest ${f.system === k ? "text-zinc-500" : "text-zinc-400"}`}>{s}</span>
            </button>
          ))}
        </div>
      </div>
      {error && <p className="text-sm text-red-400" data-testid="demo-request-error">{error}</p>}
      <Button type="submit" disabled={busy} className="w-full h-12 rounded-none bg-white text-zinc-900 hover:bg-zinc-200 text-base group" data-testid="demo-request-submit">
        {busy ? "Even geduld…" : <>Start de gratis VSM-test <ArrowRight className="h-4 w-4 ml-2 transition-transform group-hover:translate-x-1" /></>}
      </Button>
    </form>
  );
};
